import { render } from "./UsuarioShow.vue?vue&type=template&id=92bb672a"
import script from "./UsuarioShow.vue?vue&type=script&lang=js"
export * from "./UsuarioShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__